import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import {PhoneChangeMode, Step} from '../../utils';
import * as css from './PrimaryActionButton.css';
import {TXHR} from '../../../../../assets/constants/constansts.type';

type Props = {
    step: Step;
    onClose: () => void;
    onVerifyCode: (code: string) => void;
    verifyXHR?: string;
    directXHR?: string;
    sendXHR?: string;
    phoneChangeMode: PhoneChangeMode;
    codeFromStore: string;
    disabled?: boolean;
};

export default function PrimaryActionButton({step, onClose, onVerifyCode, verifyXHR, directXHR, sendXHR, phoneChangeMode, codeFromStore, disabled}: Props) {
    const {t} = useTranslation('layout');

    const phoneXHR = phoneChangeMode === 'regular' ? directXHR : sendXHR;

    const config: Record<Step, {onClick?: () => void; form?: string; xhrState?: string; label: string}> = {
        success: {
            onClick: onClose,                              
            label: t('close')
        },
        code: {
            onClick: onClose,
            label: t('close'), 
            xhrState: verifyXHR
        },
        phone: {
            form: 'phone-form',
            label: t('orderChangePhonePrimaryCta'), 
            xhrState: phoneXHR},
    };

    const {onClick, form, xhrState, label} = config[step];

    return (
        <css.primaryBtnWrap>
            <Button variant="brand" size="category" onClick={onClick} form={form} type={form ? 'submit' : 'button'} xhrState={xhrState as TXHR} disabled={disabled}>
                {label}
            </Button>
        </css.primaryBtnWrap>
    );
}
